import { render, staticRenderFns } from "./LatestSignatures.vue?vue&type=template&id=4af73b2a&scoped=true&"
import script from "./LatestSignatures.vue?vue&type=script&lang=js&"
export * from "./LatestSignatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af73b2a",
  null
  
)

export default component.exports